export default __webpack_public_path__ + "static/media/item-3.ac68561b.jpg";